var styleDataHash = "c43f29ad";
const injectCss = () => {
  var css = `._44w2p{max-height:578px;overflow:auto}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var custom_spacing_editor_modal_default = {
  "content": "_44w2p"
};
export {
  custom_spacing_editor_modal_default as default,
  injectCss
};
//# sourceMappingURL=custom-spacing-editor-modal-scss.js.map
